import SearchOrganization from './SearchOrganization';
import { Button } from '@mui/material';
import { useState } from 'react';
import crsAcls from 'src/careflow/ph-core/admin/permissions/util/crs/crsAcls';
import { checkAclValidation } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import useTenantConfigData from 'src/careflow/ph-core/multi-tenant/tenant/hook/useTenantConfigData';
import Iconify from 'src/components/Iconify';

const CreateOrganizationButton = ({
  translate,
  refresh,
}: {
  translate: any;
  refresh: () => void;
}) => {
  const { finishedLoading, configurations, componentsData } = useTenantConfigData();
  const { googleMapsApiKey } = configurations ?? {};

  const [openModal, setOpenModal] = useState(false);

  const isAllowingAdd = checkAclValidation({
    acls: [crsAcls.ADMIN.ORGANIZATIONS.ADD],
  });

  const isReady = finishedLoading && !!googleMapsApiKey;

  return (
    <>
      <Button
        disabled={!isAllowingAdd || !isReady}
        variant="contained"
        onClick={() => setOpenModal(true)}
        startIcon={<Iconify icon={'eva:plus-fill'} />}
      >
        {translate('newOrganizationButton')}
      </Button>

      {isReady && (
        <SearchOrganization
          open={openModal}
          translate={translate}
          handlerActionCreate={refresh}
          onClose={() => setOpenModal(false)}
          configurations={configurations}
          componentsData={componentsData}
        />
      )}
    </>
  );
};

export default CreateOrganizationButton;
